import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, SectionLabel } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { CONSENT_EVENT, denyAnalytics, storedConsent } from "@/lib/analytics";

export function AnalyticsPreferences() {
  const { t } = useTranslation();
  const [consent, setConsent] = useState(storedConsent);
  useEffect(() => {
    const update = () => setConsent(storedConsent());
    window.addEventListener(CONSENT_EVENT, update);
    return () => window.removeEventListener(CONSENT_EVENT, update);
  }, []);
  return <Card>
    <SectionLabel>{t("privacy_controls.title")}</SectionLabel>
    <p className="mt-2 text-[13px] text-taupe">{t("privacy_controls.paused")}</p>
    <Button className="mt-3" variant="ghost" size="sm" onClick={denyAnalytics} disabled={consent === "denied"}>
      {t(consent === "denied" ? "privacy_controls.disabled" : "privacy_controls.withdraw")}
    </Button>
  </Card>;
}
